<template>
	<v-sheet elevation="0"> </v-sheet>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"

export default {
	components: {},
	data() {
		return {
			id: this.$route.params.id,
			common,
		}
	},
	mounted() {
		this.fetchInspectionReport()
	},
	methods: {
		fetchInspectionReport() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/inspection_reports/order_individual_infos/${this.id}`
			axios
				.get(url, { headers })
				.then((res) => {})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
}
</script>
